import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=64297044&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports